import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { tv } from "tailwind-variants";

const labelVariants = tv({
  slots: {
    container: "flex",
    label: "m-0 mr-3 text-base leading-6 font-semibold text-content",
  },
});

const { container: containerSlot, label: labelSlot } = labelVariants();

export type LabelProps = {
  label: ReactNode;
  containerClassName?: string;
} & ComponentPropsWithoutRef<"label">;

export const Label = ({ className, containerClassName, label, ...props }: LabelProps) => {
  return (
    <div className={containerSlot({ className: containerClassName })}>
      {typeof label !== "string" ? (
        label
      ) : (
        <label {...props} className={labelSlot({ className })}>
          {label}
        </label>
      )}
    </div>
  );
};
